import React from 'react';
import { Input } from 'reactstrap';
import CustomCalendar from './CustomCalendar';
import moment from 'moment';

export default class CalendarToggler extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      selectedTimeslot: null,
    }

    this.toggle = this.toggle.bind(this);
    this.timeslotSelected = this.timeslotSelected.bind(this);
  }

  toggle(e) {
    if (this.props.disabled) {
      e.preventDefault();
      return;
    }
    this.setState({ modal: !this.state.modal });
  }

  timeslotSelected(timeslot) {
    this.setState({selectedTimeslot: moment(timeslot.time).format('DD. MMMM YYYY [um] HH:mm [Uhr]')});
    this.props.onTimeslotSelected(timeslot);
    this.toggle();
  }

  render() {
    return (
      <div>
        <div><label>Datum und Uhrzeit*</label></div>
        <div className="calendar-toggler-arrow-wrapper">
          <Input
            type="text"
            placeholder="Bitte Datum und Uhrzeit wählen"
            value={this.state.selectedTimeslot}
            className={"calendar-toggler" + (this.state.selectedTimeslot ? " has-value" : "") + (this.props.disabled ? " disabled" : "")}
            onClick={this.toggle}
          />
          <div className="calendar-toggler-arrow"></div>
        </div>
        <CustomCalendar
          isOpen={this.state.modal}
          toggle={this.toggle}
          prevWeek={this.props.prevWeek}
          nextWeek={this.props.nextWeek}
          availableDates={this.props.availableDates}
          availableTimes={this.props.availableTimes}
          currentWeek={this.props.currentWeek}
          calendarLoaded={this.props.calendarLoaded}
          timeslotSelected={this.timeslotSelected}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/CalendarToggler.js